import { SVGProps } from 'react';

interface CustomSVGProps extends SVGProps<SVGSVGElement> {
  fillColor1?: string;
  fillColor2?: string;
  r?: string;
}

const IconOrderInTransitModule = (props: CustomSVGProps) => {
  const { fillColor1, fillColor2, r, ...restProps } = props;
  return (
    <svg
      width='46'
      height='45'
      viewBox='0 0 46 45'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...restProps}
    >
      <g clipPath='url(#clip0_369_18500)'>
        <rect x='0.5' width='45' height='45' rx='8' fill='white' />
        <rect x='0.5' width='45' height='45' rx='8' fill='url(#paint0_linear_369_18500)' />
        <rect x='0.5' width='45' height='45' rx='8' fill={fillColor1 ?? '#ECECEC'} />
        <circle
          opacity='0.6'
          cx='35.1111'
          cy='38.5'
          r={r ?? '30'}
          fill='url(#paint1_radial_369_18500)'
          fillOpacity='0.8'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.52 15H28.8851C29.16 15 29.3851 15.225 29.3851 15.5V27.465C29.3851 27.74 29.16 27.965 28.8851 27.965H23.36C23.3901 27.8 23.405 27.635 23.405 27.465C23.405 25.755 22.0101 24.36 20.2951 24.36C18.58 24.36 17.185 25.755 17.185 27.465C17.185 27.635 17.205 27.8 17.2301 27.965H15.52C15.245 27.965 15.02 27.74 15.02 27.465V23.38H19C19.275 23.38 19.5 23.155 19.5 22.88C19.5 22.605 19.275 22.38 19 22.38H15.02V20.91H19C19.275 20.91 19.5 20.69 19.5 20.41C19.5 20.135 19.275 19.91 19 19.91H15.02V18.445H19C19.275 18.445 19.5 18.22 19.5 17.945C19.5 17.67 19.275 17.445 19 17.445H15.02V15.5C15.02 15.225 15.245 15 15.52 15ZM27.4294 20.5993C27.4378 20.579 27.445 20.5613 27.445 20.54C27.46 20.5 27.465 20.46 27.465 20.415C27.465 20.38 27.46 20.345 27.455 20.315C27.445 20.27 27.43 20.22 27.405 20.18V20.175C27.38 20.13 27.3551 20.095 27.32 20.06L26.06 18.8C25.865 18.605 25.5451 18.605 25.35 18.8C25.155 18.995 25.155 19.31 25.35 19.505L25.7601 19.915H21.905C21.625 19.915 21.405 20.14 21.405 20.415C21.405 20.69 21.625 20.915 21.905 20.915H25.755L25.35 21.315C25.155 21.51 25.155 21.83 25.35 22.025C25.4501 22.12 25.5751 22.17 25.705 22.17C25.835 22.17 25.96 22.125 26.06 22.025L27.32 20.77C27.365 20.725 27.4 20.67 27.425 20.61C27.4265 20.6063 27.428 20.6028 27.4294 20.5993ZM13.3999 19.91C13.1249 19.91 12.8999 20.135 12.8999 20.41C12.8999 20.69 13.1249 20.91 13.3999 20.91H15.0199V19.91H13.3999ZM14.5399 17.945C14.5399 18.215 14.7549 18.435 15.0199 18.445V17.445C14.7549 17.455 14.5399 17.675 14.5399 17.945ZM11.4999 22.38C11.2249 22.38 10.9999 22.605 10.9999 22.88C10.9999 23.155 11.2249 23.38 11.4999 23.38H15.0199V22.38H11.4999ZM20.2949 25.36C19.1299 25.36 18.1849 26.305 18.1849 27.465C18.1849 28.63 19.1299 29.575 20.2949 29.575C21.4549 29.575 22.4049 28.63 22.4049 27.465C22.4049 26.305 21.4549 25.36 20.2949 25.36ZM31.6899 25.36C30.5299 25.36 29.5849 26.305 29.5849 27.465C29.5849 28.63 30.5299 29.575 31.6899 29.575C32.8549 29.575 33.7999 28.63 33.7999 27.465C33.7999 26.305 32.8549 25.36 31.6899 25.36ZM34.9173 23.1728L32.2894 19.1889C32.1968 19.0488 32.0399 18.9643 31.8719 18.9643H30.3848V24.6515C30.7822 24.4664 31.2233 24.3601 31.6898 24.3601C33.4046 24.3601 34.7999 25.7529 34.7999 27.4651C34.7999 27.6047 34.7874 27.7411 34.7695 27.8759C34.905 27.7864 34.9998 27.6403 34.9998 27.4658V23.4482C34.9998 23.3503 34.971 23.2546 34.9173 23.1728Z'
          fill={fillColor2 ?? '#80888F'}
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_369_18500'
          x1='41.5'
          y1='42.5'
          x2='4.5'
          y2='3.5'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#9DBFE8' />
          <stop offset='1' stopColor='#97A9B0' />
        </linearGradient>
        <radialGradient
          id='paint1_radial_369_18500'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(35.1111 38.5) rotate(90) scale(30)'
        >
          <stop stopColor='white' stopOpacity='0.2' />
          <stop offset='0.890625' stopColor='white' stopOpacity='0.83' />
        </radialGradient>
        <clipPath id='clip0_369_18500'>
          <rect x='0.5' width='45' height='45' rx='8' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export { IconOrderInTransitModule };
